// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"c841ebc3","222":"31d6cfe0","874":"759a73dc"}[chunkId] + ".chunk.css";
};